'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BreadcrumbList = require('./BreadcrumbList.scss');

var _BreadcrumbList2 = _interopRequireDefault(_BreadcrumbList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreadcrumbList = function (_Component) {
    (0, _inherits3.default)(BreadcrumbList, _Component);

    function BreadcrumbList() {
        (0, _classCallCheck3.default)(this, BreadcrumbList);
        return (0, _possibleConstructorReturn3.default)(this, (BreadcrumbList.__proto__ || (0, _getPrototypeOf2.default)(BreadcrumbList)).apply(this, arguments));
    }

    (0, _createClass3.default)(BreadcrumbList, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['breadcrumbs', 'secondaryNavigation']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                breadcrumbs = _props.breadcrumbs,
                secondaryNavigation = _props.secondaryNavigation;


            return (0, _jsx3.default)('div', {
                className: _BreadcrumbList2.default['breadcrumb-list']
            }, void 0, (0, _jsx3.default)('div', {
                className: _BreadcrumbList2.default['breadcrumb-container']
            }, void 0, (0, _jsx3.default)('ul', {
                className: _BreadcrumbList2.default.breadcrumbs
            }, void 0, breadcrumbs), secondaryNavigation));
        }
    }]);
    return BreadcrumbList;
}(_react.Component);

exports.default = BreadcrumbList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumb/BreadcrumbList.js
// module id = CiCz
// module chunks = 57